<template>
  <router-view />

  <BottomBar />
</template>

<script>
import BottomBar from "./components/main/BottomBar.vue";

export default {
  name: "App",
  components: {
    BottomBar,
  },
};
</script>

<style>

html, body {
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  background-color: $background-color;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
